<template>
  <div class="modal__update-version">
    <img src="@/assets/superliga/training.svg" alt="training" class="modal__no-access__ticket" />
    <h3>
      {{$t('modal.updateVersionApp.legend_1')}}
      <br />
      {{$t('modal.updateVersionApp.legend_2')}}
    </h3>
    <button
      class="modal__update-version__action"
      @click.prevent="openStore"
    >{{$t('modal.updateVersionApp.action')}}</button>
  </div>
</template>
<script>
export default {
  methods: {
    async openStore() {
      const request = await this.$store.dispatch("getStoreLinks");
      window.open = window["cordova"].InAppBrowser.open;
      if (window["device"] && window["device"].platform.toLowerCase() == 'ios') {
        window.open(`${request.data.appStore.IOS}`, "_system");
      } else {
        window.open(`${request.data.appStore.android}`, "_system");
      }
    }
  },
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.modal__update-version {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 400px;
  background: $white;
  height: 260px;
  width: 100%;
  border-radius: $redondeadobig;
  margin: 0 $margin-kilo;
  position: relative;

  h3 {
    padding: $margin-kilo;
    width: 100%;
    text-align: center;
  }

  &__action {
    width: 100%;
    background: $yellow;
    color: $white;
    padding: $margin-base;
    margin-top: $margin-mega;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0 0 $redondeadobig $redondeadobig;
    z-index: 2;
    border-top: 1px solid $white;
    position: absolute;
    bottom: -8px;
  }
}
</style>